const ELECTRONIC_WASTE = 'electronicWaste';
const NO_VEHICLE = 'noVehicle';
const VEHICLE_ICON = 'vehicle';
export { ELECTRONIC_WASTE, NO_VEHICLE, VEHICLE_ICON };